import TableContainer from "../genericTable/TableContainer";
import { Alert } from "react-bootstrap";
import { useMemo } from "react";
import { ORDINATO_COLUMNS } from "./externalDataTableColumns";

export function AccountOrdinato({ accountId, loadingState, ordinato, onSelectItem }) {
  const columns = useMemo(() => ORDINATO_COLUMNS({ onSelectItem }), [onSelectItem])

  return (
    <div>
      {ordinato.error
        ? (
          <Alert variant="danger">
            {ordinato.error?.message}
          </Alert>
        )
        : <TableContainer
          dblClickCallback={onSelectItem}
          columns={columns}
          data={ordinato.data}
          loading={loadingState.isLoadingOrdinato}
          error={ordinato.error}
        ></TableContainer>
      }
    </div>
  )
}
